import Cookies from 'js-cookie'
// import secret from '@/utils/secret'

const CONSUMER_IDENTITY_KEY = 'us-key'
// console.log('CONSUMER_IDENTITY_KEY',CONSUMER_IDENTITY_KEY)
const CONSUMER_CONDITION_KEY = 'us-key'
// console.log('CONSUMER_CONDITION_KEY',CONSUMER_CONDITION_KEY)
const DO_MAIN = 'cabplink.com'
// const CONSUMER_CONDITION_KEY = 'CONSUMER_CONDITION'
const Home_Path = 'home-path'
const url = window.location.href
//详情页目录进入阅读器自带id
const FROM_CATALOGID = 'from_catalogid'

// console.log('sssssssssss1111111',getToken())
if(url.indexOf('agentToken=') != -1){
  let agentToken= url.split('agentToken=')[1];
  // console.log('sssssssssss',agentToken,getToken())
  if( getToken() ){
    if(agentToken  && agentToken != getToken()){
      // alert(1)
      removeToken()
      // window.location.replace(url)
      window.location.reload()
    }
  } else{
    setToken(agentToken,7)
    // window.location.reload()
  }
}
/** 设置消费者token信息 */
export function getToken () {
  return Cookies.get(CONSUMER_IDENTITY_KEY)
}
export function setToken (token, expiresVal) {
  let tokens;
  if(url.indexOf('agentToken=') != -1){
    let str= url.split('agentToken=');
    tokens =str[1];
  }else{
    tokens = token
  }
  return expiresVal ? Cookies.set(CONSUMER_IDENTITY_KEY, tokens, {expires: 7, domain: DO_MAIN}) : Cookies.set(CONSUMER_IDENTITY_KEY, tokens, {expires: 7, domain: DO_MAIN})
}
export function removeToken () {
  return Cookies.remove(CONSUMER_IDENTITY_KEY, {domain: DO_MAIN})
}

/** 登录状态 */
export function getConsumerCondition () {
  return Cookies.get(CONSUMER_CONDITION_KEY)
}
export function setConsumerCondition (token) {
  return Cookies.set(CONSUMER_CONDITION_KEY, token, {expires: 7, domain: DO_MAIN})
}
export function removeConsumerCondition () {
  // return Cookies.remove(CONSUMER_CONDITION_KEY, {domain: DO_MAIN})
}

/** 设置消费者状态信息 */
export function setUserToken (content) {
  Cookies.set(CONSUMER_CONDITION_KEY, content, {expires: 7, domain: DO_MAIN})
}
export function getUserToken () {
  return Cookies.get(CONSUMER_CONDITION_KEY)
}
export function removeUserToken () {
  // Cookies.remove(CONSUMER_CONDITION_KEY, {domain: DO_MAIN})
}

export function removeB () {
  return Cookies.remove(CONSUMER_CONDITION_KEY,{domain: DO_MAIN})
}

//获取来源地址
export function setFromHomePath (content) {
 return  Cookies.set(Home_Path, content, {expires: 7, domain: DO_MAIN})
}
export function getFromHomePath () {
 return Cookies.get(Home_Path)
}
export function removeFromHomePath () {
 return Cookies.remove(Home_Path,{domain: DO_MAIN})
}
/** 来自详情页目录 */
export function getFromCatalogid () {
  return Cookies.get(FROM_CATALOGID)
}
export function setFromCatalogid (id) {
  return Cookies.set(FROM_CATALOGID, id, {expires: 7, domain: DO_MAIN})
}
export function removeFromCatalogid () {
  return Cookies.remove(FROM_CATALOGID, {domain: DO_MAIN})
}



// WEBPACK FOOTER //
// ./src/utils/cookies.js